import { ReleaseCard } from '../components/release-card.component'
import type { useReleaseNote } from '../hooks/use-release-note.hook'

type ReleaseNotesInterfaceProps = ReturnType<typeof useReleaseNote>
export function ReleaseNotesInterface({
  releases,
}: ReleaseNotesInterfaceProps) {
  return (
    <div>
      {releases.map((release) => (
        <ReleaseCard key={release.id} release={release} />
      ))}

      {!releases.length && (
        <div className="w-full h-[70vh] flex justify-center items-center">
          <p>Não há notas de atualização disponíveis.</p>
        </div>
      )}
    </div>
  )
}
